import React, { useEffect, useState } from "react";
import Router from "./Router";
import LogRocket from "logrocket";
import Offline from "./screen/offline/Offline";

const App: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    LogRocket.init('v8myyq/ngabsign-id');
  }, []);

  useEffect(() => {
    const handleOffline = () => setIsOnline(false);
    const handleOnline = () => setIsOnline(true);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOnline) {
    return <Offline />;
  }

  return <Router />;
}

export default App